export default "__VITE_PUBLIC_ASSET__5a6bbca5__"